import { render } from "./BaseModal.vue?vue&type=template&id=00dd9dec&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=00dd9dec&scoped=true&lang=css"
import "./BaseModal.vue?vue&type=style&index=1&id=00dd9dec&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dd9dec"]])

export default __exports__